import { SeverityAlert } from 'common-types';
import { FilterElements } from '../common/filters-utils/filters-utils';
import { RepoTypes } from 'common-types';

export interface PipelineSummaryResponse {
  offset: number;
  total: number;
  pipelineSummaries: PipelineSummary[];
  totalFiltered: number;
}

export interface GetPipelineSummaryInput {
  limit: number;
  offset: number;
  filters?: {};
  dateRange?: {
    from: number;
    to: number;
  };
  owners?: string[];
}

export interface PipelineSummary {
  apps: {
    appId: string;
    appName: string;
    appType: RepoTypes;
  }[];
  targetBranch: string;
  sourceBranch: string;
  result: string;
  jobId: string;
  jobTriggeredBy: string;
  jobTriggeredAt: string;
  jobTriggeredReason: string;
  jobUrl: string;
  totalIssues: string;
  totalBlockingIssues: string;
  pullRequestId: string;
  pullRequestUrl: string;
  issues: SeverityAlert;
  eventType: string;
}

export interface FilterPipelineSummaryType {
  apps: FilterElements[];
}

export interface FetchPipelineSummaryFiltersResponse {
  getPipelineSummaryFilters: FilterPipelineSummaryType;
}

export enum EventType {
  Merge = 'Merge',
  Push = 'Push',
  PullRequest = 'Pull Request',
}
